import {useContext} from 'react'
import {ITrackingContext, TrackingContext} from './Tracking.context'

export const useTracking = (): ITrackingContext => {
  return useContext(TrackingContext)
}
